
export default {
  PRIMARY: "#001E6C",
  SECONDARY: "#035397",
}

